import { Injectable } from '@angular/core';
import { LIGHT_MODE } from '@core/constants/theme-modes';

@Injectable({
  providedIn: 'root'
})
export class ThemeModeService {

  getLocalStorageThemeMode = (): 'light' | 'dark' => {
    const savedTheme = localStorage.getItem('theme-mode');
    return (savedTheme as 'light' | 'dark') ||  LIGHT_MODE;
  }
  
  setLocalStorageThemeMode = (newMode: 'light' | 'dark') => {
    localStorage.setItem('theme-mode', newMode);
  }

}
